import { FC, ReactNode, useCallback } from 'react'
import { useNetworkStatus } from '@shared/hooks/useNetworkStatus'
import { YellowFilledButton } from '@shared/styles/YellowFilledButton'
import offlineImage from '@images/offline.png?inline'

export const NetworkStatusProvider: FC<{ children: ReactNode }> = ({ children }) => {
	const isOnline = useNetworkStatus()

	const handleRetry = useCallback(() => {
		window.location.reload()
	}, [])

	return (
		<>
			{children}
			{!isOnline && (
				<div className='fixed inset-0 z-[999] flex flex-col bg-white'>
					<div className='flex flex-1 flex-col items-center justify-center text-center px-6'>
						<img
							src={offlineImage}
							alt=''
							style={{ width: 168, height: 152 }}
							className='mb-6'
						/>

						<h1 className='text-[22px] font-extrabold text-[#101113] mb-2'>
							Нет соединения
						</h1>

						<p className='text-[15px] text-[#7A7A7C] leading-relaxed max-w-[280px] mb-8'>
							Похоже, интернет не доступен. Проверьте соединение и попробуйте еще раз.
						</p>

						<YellowFilledButton
							type='button'
							onClick={handleRetry}
							width={280}
							height={52}
							style={{ fontSize: 16, fontWeight: 600 }}
						>
							Повторить
						</YellowFilledButton>
					</div>
				</div>
			)}
		</>
	)
}
